export type FormConfigProductType = {
  action: string;
};

export type FormConfigType = Record<
  Queries.kontent_item_product_contact_form_elements_product_enum,
  FormConfigProductType
>;

const config: FormConfigType = {
  sonarcloud: {
    action: 'https://formspree.io/f/maygjwoj',
  },
};

export default config;
